import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { offer } from "../data/offer";
import { PendingNote } from "./PendingNote";
export function GuaranteeSection() {
  return <section className="bg-mint py-16 md:py-20" data-id="element-134" data-mp="9umiexn2jy9x">
      <div className="wrap" data-id="element-135" data-mp="9srwbg02a049">
        <div className="mx-auto flex max-w-[900px] flex-col items-center gap-8 rounded-3xl border-2 border-gold/50 bg-white p-8 text-center shadow-[0_16px_40px_rgba(20,39,85,0.08)] md:flex-row md:p-12 md:text-left" data-id="element-136" data-mp="9wpg83ugqvp7">
          <div className="flex h-32 w-32 shrink-0 items-center justify-center rounded-full border-4 border-gold bg-forest" data-id="element-137" data-mp="ntvx1svmmkbs">
            <ShieldCheckIcon className="h-14 w-14 text-gold" strokeWidth={1.6} aria-hidden="true" data-id="element-138" data-mp="skkrnh2lrxf5" />
          </div>
          <div className="flex-1" data-id="element-139" data-mp="xim8dvck3kng">
            <span className="text-xs font-bold uppercase tracking-[2.5px] text-gold-dark" data-id="element-140" data-mp="xlrx39h9wkin">Garantía</span>
            <h2 className="display-title mt-2 text-[clamp(36px,4.5vw,52px)] text-ink" data-id="element-141" data-mp="12h78lurt64bw">
              {offer.guarantee ? offer.guarantee.title : "Tu compra, respaldada"}
            </h2>
            <div className="mt-4" data-id="element-142" data-mp="25pub9h2btwjp">
              {offer.guarantee ? <p className="text-muted" data-id="element-143" data-mp="20s2fud2h3sar">{offer.guarantee.terms}</p> : <PendingNote data-id="element-144" data-mp="1vuso2qrm34jr">condiciones exactas de la garantía (plazo y cómo solicitarla).</PendingNote>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}